export default {
  hideMessageTimeout: 2000,
  objectTypes: ["text","richtext","image","croppedimage","gallery","datepicker","dropdown", "boolean", "files", "content"],
  contentLanguages: ["Nl","Fr","En"],
  languages: ["Nl","Fr"],
  logoPos: "kjell-vandewalle-logo-pos.png",
  logoNeg: "kjell-vandewalle-logo.png",
  websiteName: "Kjell Vandewalle",
  primaryColor: "#92c043",
  mailto: "info@vandewallekjell.be"
}
